<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">BANNERS</h1>
        </section>

        <section id="table">
            <mat-card class="mat-elevation-z0">
                <div>
                    <button mat-flat-button class="add-btn" (click)="addBanner()">Agregar nuevo</button>
                </div>

                <table mat-table [dataSource]="allBaners" class="mat-elevation-z0">

                    <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef class="table-header">CIUDAD</th>
                        <td mat-cell *matCellDef="let banner"> {{banner.cdCity | getBannerCity | async | uppercase }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="image">
                        <th mat-header-cell *matHeaderCellDef class="table-header">IMAGEN</th>
                        <td mat-cell *matCellDef="let banner">
                            <img class="table-image" [src]="banner.dsImageUrl" />
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef class="table-header">POSICIÓN</th>
                        <td mat-cell *matCellDef="let banner"> {{banner.nmPosition | getBannerPosition}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
                        <td mat-cell *matCellDef="let banner">
                            <p [style.color]="banner.isActive ? 'blue' : '#F44336'">{{banner.isActive | status}}</p>
                            <button mat-flat-button (click)="changeBannerStatus(banner.cdBanner, banner.isActive)"
                                [ngClass]="{'activate-btn': !banner.isActive, 'deactivate-btn': banner.isActive}">
                                {{banner.isActive | changeStatus}}</button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="option">
                        <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
                        <td mat-cell *matCellDef="let banner">
                            <button mat-mini-fab class="edit-btn" 
                            matTooltip="Editar banner" (click)="editBanner(banner.cdBanner)">
                                <mat-icon>create</mat-icon>
                            </button>
                            <button mat-mini-fab class="delete-btn"
                            matTooltip="Eliminar banner" (click)="deleteBanner(banner.cdBanner)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>
